export const getFieldConfig = (accountVal, fieldName) => {
  const val = accountVal?.[fieldName];

  if (val === undefined || val === null) {
    return { isRequired: true };
  }

  if (val === true) {
    return { isRequired: true };
  }

  if (val === false) {
    return { isRequired: false };
  }

  return { isRequired: true };
};
